import { render } from "./IntegracaoPf.vue?vue&type=template&id=5b978e60"
import script from "./IntegracaoPf.vue?vue&type=script&lang=js"
export * from "./IntegracaoPf.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__